import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-71cbd40b")

_pushScopeId("data-v-71cbd40b")
const _hoisted_1 = { class: "error" }
const _hoisted_2 = { class: "error__container" }
const _hoisted_3 = { class: "error__text" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "display-2" }, "Oops!", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "heading-6" }, " We can't seem to find the page you're looking for. ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_NavBar = _resolveComponent("NavBar")
  const _component_ThothButton = _resolveComponent("ThothButton")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_NavBar, { "logged-in": _ctx.isLoggedIn }, null, 8, ["logged-in"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("img", {
          src: _ctx.errorImage,
          class: "error__image",
          alt: "error-image"
        }, null, 8, ["src"]),
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _createVNode(_component_router_link, { to: "/dashboard" }, {
            default: _withId(() => [
              _createVNode(_component_ThothButton, {
                text: "RETURN TO THOTH",
                size: _ctx.ButtonSize.M,
                emphasis: _ctx.ButtonEmphasis.Contained,
                colour: _ctx.ButtonColour.Brand
              }, null, 8, ["size", "emphasis", "colour"])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 64))
})